
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocation3 as ObiLocation3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-3.js';
 
 
 

 
 export const ObiLocation3 = createComponent({
   react: React,
   tagName: 'obi-location-3',
   elementClass: ObiLocation3Element,
   events: {
     
   }
  });
 
 